import './find-events.scss';

document.addEventListener('DOMContentLoaded', function() {
	'use strict';

	const filterForm = document.getElementById('events-filter-form');
	const resultsContainer = document.querySelector('.find-events-results');
	const resultsTitle = document.querySelector('.events-results-title');
	let timer;

	// Store the current view type
	let currentViewType = 'upcoming'; // Default view

	// Function to clear all filters and search inputs
	function clearFilters() {
		if (!filterForm) return;

		// Reset all select elements to their first option
		const selectInputs = filterForm.querySelectorAll('select');
		selectInputs.forEach(select => {
			select.selectedIndex = 0;
		});

		// Clear all text inputs
		const textInputs = filterForm.querySelectorAll('input[type="text"]');
		textInputs.forEach(input => {
			input.value = '';
		});

		// Clear any other input types if needed
		const checkboxes = filterForm.querySelectorAll('input[type="checkbox"]');
		checkboxes.forEach(checkbox => {
			checkbox.checked = false;
		});
	}

	// Function to update results with optional action type parameter
	function updateResults(actionType = null, isFilterChange = false, shouldClearFilters = false) {
		// Check if form and results container exist
		if (!filterForm) {
			console.error('Events filter form not found');
			return;
		}

		if (!resultsContainer) {
			console.error('Results container not found');
			return;
		}

		// Clear filters if requested
		if (shouldClearFilters) {
			clearFilters();
		}

		const formData = new FormData(filterForm);
		const searchParams = new URLSearchParams();

		for (const [key, value] of formData.entries()) {
			searchParams.append(key, value);
		}

		// Add loading state
		resultsContainer.classList.add('loading');

		// Create fetch parameters
		const fetchParams = {
			action: 'filter_events',
			nonce: events_filter_ajax.nonce,
			formData: searchParams.toString()
		};

		// If it's a filter change or search, set action_type to all_events
		if (isFilterChange && !actionType) {
			actionType = 'all_events';
		}

		// Add action_type if provided
		if (actionType) {
			fetchParams.action_type = actionType;
		}

		// Create and configure the fetch request
		fetch(events_filter_ajax.ajax_url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams(fetchParams)
		})
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then(response => {
				if (response.success) {
					resultsContainer.innerHTML = response.data.html;

					// Update the title from the server's response
					if (resultsTitle && response.data.title) {
						resultsTitle.textContent = response.data.title;
					}

					// Update the current view type
					if (response.data.viewType) {
						currentViewType = response.data.viewType;
						updateButtonStates(currentViewType);
					}
				} else {
					resultsContainer.innerHTML = '<div class="error">An error occurred. Please try again.</div>';
				}
			})
			.catch(() => {
				console.error('Error:', error);
				resultsContainer.innerHTML = '<div class="error">An error occurred. Please try again.</div>';
			})
			.finally(() => {
				resultsContainer.classList.remove('loading');
			});
	}

	// Function to update button active states
	function updateButtonStates(viewType) {
		const allEventsButton = document.querySelector('.all-events-button');
		const upcomingEventsButton = document.querySelector('.upcoming-events-button');

		if (allEventsButton || upcomingEventsButton) {
			if (viewType === 'all') {
				allEventsButton.classList.add('active');
				upcomingEventsButton.classList.remove('active');
			} else if (viewType === 'upcoming') {
				upcomingEventsButton.classList.add('active');
				allEventsButton.classList.remove('active');
			}
		}
	}

	// Only set up event handlers if the necessary elements exist
	if (filterForm) {
		// Handle select inputs change
		const selectInputs = filterForm.querySelectorAll('select');
		selectInputs.forEach(select => {
			select.addEventListener('change', function() {
				// Pass true as second parameter to indicate it's a filter change
				updateResults(null, true);
			});
		});


		// Remove the need for a submit button by preventing default form submission
		filterForm.addEventListener('submit', function(e) {
			e.preventDefault();
			updateResults(null, true);
		});
	}


	// Handle text search with debounce
	const searchInput = document.getElementById('event_search');
	if (searchInput) {
		searchInput.addEventListener('input', function() {
			clearTimeout(timer);
			// Pass true as second parameter to indicate it's a search input change
			timer = setTimeout(function() {
				updateResults(null, true);
			}, 500);
		});
	}

	// Handle All Events button click
	const allEventsButton = document.querySelector('.all-events-button');
	if (allEventsButton) {
		allEventsButton.addEventListener('click', function(e) {
			e.preventDefault();
			updateResults('all_events', false, true);
		});
	}

	// Handle Upcoming Events button click
	const upcomingEventsButton = document.querySelector('.upcoming-events-button');
	if (upcomingEventsButton) {
		upcomingEventsButton.addEventListener('click', function(e) {
			e.preventDefault();
			updateResults('upcoming_events', false, true);
		});
	}

	// Initialize button states based on default view
	updateButtonStates(currentViewType);

});